import { BASE_URL } from './env'

export const ACCOUNT_SUBDOMAIN = 'account'

/**
 * Dynamic route segment name for the product parameter.
 * Matches the `[product]` folder under `src/app/(index)/`.
 */
export const PRODUCT_ROUTE_PARAM = 'product'

export const CONVERSATION_THREAD_ID_ROUTE_PARAM = 'threadId'

export const routes = {
  alerts: '/alerts',
  account: '/select-account',
  healthCheck: '/health-check',
  generatedChromium: '/chromium-pack.tar',
  login: '/login',
  mcpLogin: '/mcp-login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  updatePassword: '/update-password',
  index: '/',
  myPreferences: '/my-preferences',
  noProducts: '/no-products',
  templates: '/slides/templates',
}

export const urls = {
  account: `https://${ACCOUNT_SUBDOMAIN}.${BASE_URL}${routes.account}`,
}
